<template>
  <template v-for="(item, itemIndex) in sidebarMenu" :key="itemIndex">
    <h4 v-if="!!item.title">{{ item.title }}</h4>
    <VerticalMenuItemElement
      v-for="(menu, menuIndex) in item.menuItems"
      :key="menuIndex"
      :icon="menu.icon"
      :label="menu.label"
      :name="menu.name"
      :is-active="menu.isActive" />
  </template>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { VerticalMenuItemElement } from '@shared/components/elements';
import { type SidebarNs } from '@shared/types';

export default defineComponent({
  name: 'VerticalMenuBodyWidget',
  components: {
    VerticalMenuItemElement,
  },
  props: {
    sidebarMenu: {
      type: Array as PropType<SidebarNs.SidebarMenu[]>,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
  h4 {
    color: var(--text-neutral);
    margin: var(--space-24) var(--space-0);
    font-size: var(--fs-11);
    font-weight: 500;
    text-transform: uppercase;

  }
</style>
